import { DEPLOYMENT_ENVIRONMENT } from 'env/environments';
import { ZillowDomain } from 'src/common/constants';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';

export const getIntegrationZillowOriginForDeploymentEnvironment = (): string => {
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    const { ENV } = publicRuntimeConfig;
    switch (ENV) {
        case DEPLOYMENT_ENVIRONMENT.PRODUCTION:
            return ZillowDomain.PROD;
        default:
            return ZillowDomain.NON_PROD;
    }
};
